import { c as _c } from "react/compiler-runtime";
import { Badge } from '@achra/ui/badge';
import { cn } from '@achra/ui/lib/utils';
import { BADGE_CONFIG } from '../../lib/constants';
import type { ServiceBadge as ServiceBadgeType } from '../../types';
interface ServiceBadgeProps {
  badge: ServiceBadgeType;
  className?: string;
}
function ServiceBadge(t0) {
  const $ = _c(6);
  const {
    badge,
    className
  } = t0;
  const config = BADGE_CONFIG[badge];
  let t1;
  if ($[0] !== className || $[1] !== config.className) {
    t1 = cn("border-none text-xs font-medium", config.className, className);
    $[0] = className;
    $[1] = config.className;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== config.label || $[4] !== t1) {
    t2 = <Badge variant="outline" className={t1}>{config.label}</Badge>;
    $[3] = config.label;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export { ServiceBadge };